import React from 'react';
import { Container, Row, Col, Card, Button, Badge, Table, ProgressBar } from 'react-bootstrap';
import { useTheme } from '../../context/ThemeContext';

const EmailMarketingPage: React.FC = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const campaigns = [
    { id: 1, name: 'Welcome Series', status: 'active', sent: 12000, open: 42, click: 8 },
    { id: 2, name: 'Weekly Newsletter', status: 'active', sent: 8500, open: 38, click: 6 },
    { id: 3, name: 'Promo Blast', status: 'paused', sent: 0, open: 0, click: 0 },
  ];

  return (
    <Container fluid className="py-4">
      <style>{`
        .email-title { color: ${isDark ? '#e2e8f0' : '#111827'}; }
        .email-card { background: ${isDark ? '#1f2937' : '#ffffff'}; border: 1px solid ${isDark ? '#334155' : '#e9ecef'}; box-shadow: ${isDark ? '0 4px 16px rgba(0,0,0,0.5)' : '0 2px 8px rgba(0,0,0,0.08)'}; }
        .email-table th { background: ${isDark ? '#0b1220' : '#f8f9fa'}; color: ${isDark ? '#e5e7eb' : '#495057'}; }
        .email-table td { color: ${isDark ? '#e5e7eb' : 'inherit'}; }
      `}</style>

      <Row className="mb-4 align-items-center">
        <Col>
          <h2 className="fw-bold email-title">Email Marketing</h2>
        </Col>
        <Col xs="auto">
          <Button variant="primary">Create Campaign</Button>
        </Col>
      </Row>

      <Row className="g-4">
        <Col lg={4}>
          <Card className="email-card">
            <Card.Body>
              <h5 className="fw-semibold mb-3">Overview</h5>
              <div className="mb-3">
                <div className="d-flex justify-content-between mb-1"><span>Open Rate</span><span>39%</span></div>
                <ProgressBar now={39} variant="success" style={{ height: 8 }} />
              </div>
              <div>
                <div className="d-flex justify-content-between mb-1"><span>Click Rate</span><span>7%</span></div>
                <ProgressBar now={7} variant="info" style={{ height: 8 }} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={8}>
          <Card className="email-card">
            <Card.Body>
              <h5 className="fw-semibold mb-3">Campaigns</h5>
              <Table responsive className="email-table mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Sent</th>
                    <th>Open%</th>
                    <th>Click%</th>
                    <th style={{ width: 120 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map(c => (
                    <tr key={c.id}>
                      <td>{c.name}</td>
                      <td><Badge bg={c.status === 'active' ? 'success' : 'secondary'}>{c.status}</Badge></td>
                      <td>{c.sent.toLocaleString()}</td>
                      <td>{c.open}%</td>
                      <td>{c.click}%</td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button size="sm" variant="outline-primary">View</Button>
                          <Button size="sm" variant="outline-secondary">Edit</Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmailMarketingPage;